import { SearchTypeResponse } from 'domain/config';
import produce, { Draft } from 'immer';
import { Categories } from '../domain/category';
import { Laboratories } from '../domain/laboratories';
import { LotsProductPaginated } from '../domain/Lots';
import { PresentationType } from '../domain/presentation-type';
import { Presentation, Products, ProductsPaginated } from '../domain/product';
import { Suppliers } from '../domain/suppliers';
import { InventoryAction, InventoryDispatchObject } from './actions';

export interface InventoryState {
  title: string;
  productSelected: Products | null;
  presentation: Presentation | null;
  productList: ProductsPaginated;
  lotList: LotsProductPaginated;
  laboratories: Laboratories[] | null;
  categories: Categories[] | null;
  suppliers: Suppliers[] | null;
  presentationTypes: PresentationType[] | null;
  codeTypes: SearchTypeResponse | null;
}

export const initialState: InventoryState = {
  title: 'Inventario',
  productSelected: null,
  productList: {
    data: [],
    page: 0,
    size: 0,
    total: 0,
  },
  lotList: {
    data: [],
    page: 0,
    size: 0,
    total: 0,
  },
  presentation: null,
  laboratories: null,
  categories: null,
  suppliers: null,
  presentationTypes: null,
  codeTypes: null,
};

export const inventoryContextReducer = produce((draft: Draft<InventoryState>, { type, payload }: InventoryDispatchObject<any>) => {
  switch (type) {
    case InventoryAction.ClearState:
      return initialState;

    case InventoryAction.ProductSelected:
      draft.productSelected = payload;
      break;

    case InventoryAction.Presentation:
      draft.presentation = payload;
      break;

    case InventoryAction.ProductList:
      draft.productList = payload;
      break;
    case InventoryAction.LotList:
      draft.lotList = payload;
      break;

    case InventoryAction.Laboratories:
      draft.laboratories = payload;
      break;

    case InventoryAction.Categories:
      draft.categories = payload;
      break;

    case InventoryAction.Suppliers:
      draft.suppliers = payload;
      break;

    case InventoryAction.PresentationTypes:
      draft.presentationTypes = payload;
      break;

    case InventoryAction.CodeTypes:
      draft.codeTypes = payload;
      break;

    default:
      throw new Error(`Unknown inventory action type: ${type}`);
  }
});
